export default "__VITE_ASSET__BEkHictb__"